import { motion } from 'framer-motion';
import { useI18n } from '../context/I18nContext';
import { FileEdit, ScanSearch, RefreshCw, Highlighter, WifiOff, Shield } from 'lucide-react';

const iconMap = { FileEdit, ScanSearch, RefreshCw, Highlighter, WifiOff, Shield };

export const SolutionSection = () => {
  const { t } = useI18n();
  const features = t('solution.features');

  return (
    <section id="features" className="relative py-16 sm:py-24 md:py-32 bg-muted" data-testid="solution-section">
      <div className="absolute top-0 right-0 w-[300px] sm:w-[500px] h-[300px] sm:h-[400px] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-500/8 via-transparent to-transparent" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-10 sm:mb-16">
          <span className="text-xs uppercase tracking-[0.2em] text-emerald-600 dark:text-emerald-400/70 font-medium" data-testid="solution-tag">{t('solution.tag')}</span>
          <h2 className="font-heading text-2xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-foreground mt-3" data-testid="solution-title">{t('solution.title')}</h2>
        </motion.div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.isArray(features) && features.map((f, i) => {
            const Icon = iconMap[f.icon] || Shield;
            return (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
                className="group relative p-8 rounded-2xl bg-card border border-border hover:border-blue-500/30 transition-all duration-500 overflow-hidden"
                data-testid={`feature-card-${i}`}>
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-500/5 via-transparent to-transparent" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-5 group-hover:bg-blue-500/20 transition-colors duration-300">
                    <Icon className="w-6 h-6 text-blue-500" />
                  </div>
                  <h3 className="text-foreground font-semibold text-lg mb-2">{f.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{f.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
